export default __webpack_public_path__ + "locales/bg/FillPDFDialog.json?hash=1274f6d56d11ed65e8fa837883f6ca80";